export default (value, unit) => {
  if ((value === 0 || value) && unit) {
    return `${value} ${unit}${value === 1 ? '' : 's'}`;
  }

  return '';
};
